import React from "react";
import "./perfectVilla.css";
import villaIocn4 from "../../images/home/villaIcon4.png";
import villaIocn3 from "../../images/home/villaIcon3.png";
import villaIocn2 from "../../images/home/villaIcon2.png";
import villaIocn1 from "../../images/home/villaIcon1.png";

const PerfectVilla = () => {
  return (
    <div className="text-white py-10 max-md:px-4 max-w-[1440px] mx-auto">
      <div className="text-xl text-[#585858] poppins-medium text-center">
        FEATURES OF YOUR DREAM VILLAS
      </div>
      <h2 className="text-center mt-2 tracking-wide md:tracking-wider leading-tight md:leading-snug text-3xl md:text-[46px] font-bold text-[#672220]">
        Feel Like Home in a Villa <br />
        Made For You
      </h2>

      <div className="relative mt-10 flex flex-col lg:flex-row items-center justify-between w-full gap-10">
        {/* Left Side - Cards */}

        <div className="w-full lg:w-1/2 h-[550px] lg:hidden flex justify-center items-center bg-cover bg-center perfectVilla"></div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 z-10 w-full lg:w-1/2">
          <div className="bg-white p-6 rounded-xl shadow-custom flex flex-col items-start">
            <img
              src={villaIocn1}
              alt="Trusted"
              className="w-[74px] h-[74px] mb-3"
            />
            <h3 className="text-base text-[#1A1A1A] font-black">
              Tailored Experience
            </h3>
            <p className="text-[#585858] font-normal text-[12px] mt-3 ">
              with modern amenities
            </p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-custom flex flex-col items-start">
            <img
              src={villaIocn2}
              alt="Luxury"
              className="w-[74px] h-[74px] mb-3"
            />
            <h3 className="text-base text-[#1A1A1A] font-black">
              Charming Terrace Lounge
            </h3>
            <p className="text-[#585858] font-normal text-[12px] mt-3">
              with Bali Nets & Jacuzzi
            </p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-custom flex flex-col items-start">
            <img
              src={villaIocn3}
              alt="Secure"
              className="w-[74px] h-[74px] mb-3"
            />
            <h3 className="text-base text-[#1A1A1A] font-black">
              On-Site Local Staff
            </h3>
            <p className="text-[#585858] font-normal text-[12px] mt-3">
              eager to help
            </p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-custom flex flex-col items-start">
            <img
              src={villaIocn4}
              alt="360 Tours"
              className="w-[74px] h-[74px] mb-3"
            />
            <h3 className="text-base text-[#1A1A1A] font-black">
              Home-Style Food
            </h3>
            <p className="text-[#585858] font-normal text-[12px] mt-3">
              served with love
            </p>
          </div>
        </div>

        {/* Right Side - Background Image */}
        <div className="ml-[-40px] w-1/2 h-[550px] hidden lg:flex justify-center items-center bg-cover bg-center perfectVilla"></div>
      </div>
    </div>
  );
};

export default PerfectVilla;
